import { IconProps } from 'types/icon.type'

export const TickHeavyIcon = (props: IconProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Tick heavy icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0581 3.58443C12.3261 3.8782 12.3116 4.33964 12.0258 4.61509L5.97261 10.4484C5.69974 10.7114 5.27511 10.7114 5.00219 10.4485L1.97431 7.53188C1.68842 7.25649 1.67387 6.79505 1.94181 6.50122C2.20976 6.20739 2.65873 6.19244 2.94462 6.46783L5.48724 8.91705L11.0553 3.55125C11.3411 3.2758 11.7901 3.29066 12.0581 3.58443Z"
        fill="currentColor"
      />
    </svg>
  )
}
